import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const modules = {
    toolbar: [
      ['bold', 'italic'],
      [{ list: 'bullet' }],
      ['clean'],
    ],
  };

  return (
    <div className="resume-quill-editor font-serif bg-white text-gray-900 border border-gray-300 rounded overflow-hidden">
      <ReactQuill 
        theme="snow" 
        value={value} 
        onChange={onChange} 
        modules={modules} 
        placeholder={placeholder}
      />
      <style>{`
        .resume-quill-editor .ql-container {
          font-family: inherit;
          font-size: 15px;
          border-bottom: none !important;
          border-left: none !important;
          border-right: none !important;
        }
        .resume-quill-editor .ql-toolbar {
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          background-color: #f9fafb;
        }
        .resume-quill-editor .ql-editor {
          padding: 12px 14px;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
